import {
  CascoCategoryEnum,
  CascoCommonPeriodEnum,
  CascoTerritoryType,
  ContractorType,
  InstallmentsEnum,
  PackageEnum
} from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps, onlyVehicle } from './utils'

export const InsurancePackage = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const {
    insurancePackageProps,
    vehicleCategoryProps,
    officialDealerRepairProps,
    territoryProps,
    contractorProps,
    periodProps,
    installmentsProps
  } = formProps(t)
  const formInstance = Form.useFormInstance()
  const { isEditable } = useCascoInsuranceValues()

  const options = Object.values(PackageEnum).map((value) => ({
    label: t(value),
    value,
    colProps: { xs: 24, lg: 12 }
  }))

  const insurancePackage = Form.useWatch<PackageEnum>(
    insurancePackageProps.name,
    { preserve: true }
  )

  useEffect(() => {
    if (insurancePackage === PackageEnum.FIFTY_FIFTY) {
      formInstance.setFieldValue(installmentsProps.name, InstallmentsEnum._1)
    }

    if (!onlyVehicle(insurancePackage)) return

    formInstance.setFieldValue(
      vehicleCategoryProps.name,
      CascoCategoryEnum.AUTOMOBILE
    )

    if (insurancePackage === PackageEnum.MINI) {
      formInstance.setFieldValue(territoryProps.name, CascoTerritoryType.MD)
      formInstance.setFieldValue(periodProps.name, CascoCommonPeriodEnum._12)
      formInstance.setFieldValue(contractorProps.name, {
        ...formInstance.getFieldValue(contractorProps.name),
        content_type: ContractorType.PERSON
      })
    }
  }, [
    formInstance,
    insurancePackage,
    vehicleCategoryProps.name,
    officialDealerRepairProps.name,
    territoryProps.name,
    contractorProps.name,
    periodProps.name,
    installmentsProps.name
  ])

  return (
    <Form.Item {...insurancePackageProps} rules={[required]}>
      <RadioCardGroup disabled={isEditable} options={options} />
    </Form.Item>
  )
}
